const CONFIG = {
  EMAIL: 'post@coverme.no',
  ADVANCE_PURCHASE_INFO_LINK: '',
  SUPPORT_LINK: '',
  MAIN_LINK: {
    vehicle: 'https://coverme.no',
    travel: 'https://coverme.no',
    content: 'https://coverme.no',
  },
  MYPAGES_LOGOUT_REDIRECT: {
    vehicle: 'https://coverme.no',
    travel: 'https://coverme.no',
    content: 'https://coverme.no',
  },
  INSURANCE: 'https://forsikring.coverme.no/forsikring',
  PRIVACY_POLICY_LINK: 'https://www.coverme.no/personopplysninger',
  PARTNER_PRIVACY_POLICY_LINK: 'https://coverme.no',
  PARTNER_NAME: 'CoverMe',
  PARTNER_NAME_AVTALEGIRO: 'CoverMe',
  VIPPS_AUTH: true,
  TRANSLATION_LANGUAGES: ['no-NO'],
  GOOGLE_RECAPTCHA_LINKS: {
    PRIVACY: 'https://policies.google.com/privacy?hl=no',
    TERMS: 'https://policies.google.com/terms?hl=no',
  },
  FNOL: {
    PageWindshield: {
      iconLink: 'https://booking.bilglass.no/',
    },
    PageRoadsideAssistance: {
      iconLink: 'https://rsa2.falck.no/',
    },
  },
  REVIEW_LINK: 'https://forsikring.coverme.no/forsikring/coverme-reiseforsikring',
  DOCUMENTS: {
    PRIVACY_STATEMENT: '',
    LP: {
      IPID: '',
      ANSVAR: '',
      DELKASKO: '',
      KASKO: '',
      SUPER: '',
    },
  },
}

export default CONFIG
